import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type RequestOwnerColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const requestOwnerColumnConfig = <T extends TableRow>({
  options,
}: RequestOwnerColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'requestOwner',
  label: <Trans i18nKey="request_owner" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'requestOwner',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
